import {DragDropContext} from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import Filters from './Filters';

export default DragDropContext(HTML5Backend)(Filters);
